import styled from 'styled-components';
import Container from 'components/domain/container/Container';
import { Button } from '@hotelplan/components.common.buttons';

export const Nav = styled.nav(({ theme: { media, colors, space } }) => ({
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  background: colors.white,
  padding: `${space[4]} 0`,
  [media.mobile]: {
    padding: '12px 0',
  },
}));

export const NavContainer = styled(Container)(({ theme: { media } }) => ({
  width: '100%',
  [media.mobile]: {
    padding: '0 4px',
  },
}));

export const NavUl = styled.ul(({ theme: { media, space } }) => ({
  display: 'flex',
  gap: '2px',
  [media.mobile]: {
    overflow: 'auto',
  },
  [media.desktop]: {
    gap: space[7],
  },
}));

export const NavItem = styled.li({
  '&:focus-visible': {
    outline: 'none',
  },
});

export const NavButton = styled(Button)(
  ({ theme: { media, colors, space } }) => ({
    padding: '8px 10px',
    border: '2px solid',
    borderColor: 'transparent',
    borderRadius: '3px',
    color: colors.darkGrey,
    whiteSpace: 'nowrap',
    lineHeight: '22px',
    letterSpacing: '0.5px',
    cursor: 'pointer',
    [media.mobile]: {
      transition: 'none',
    },
    [media.desktop]: {
      padding: `${space[2]} ${space[3]}`,
    },
    '&:hover': {
      color: colors.redHover,
      borderBottom: '2px solid',
      borderBottomColor: colors.redHover,
    },
    '&:active': {
      color: colors.redActive,
      borderBottom: '2px solid',
      borderBottomColor: colors.redActive,
    },
    '&:focus-visible': {
      color: colors.redActive,
      outline: '1px solid',
      outlineColor: colors.darkGrey,
      transition: 'none',
      borderRadius: 0,
      [media.mobile]: {
        outline: 'none',
        border: `1px solid ${colors.darkGrey}`,
        padding: '9px 11px',
      },
    },
  })
);
